<template>
  <div class="wrapper">

    <side-bar>
      <template slot="links">

        <sidebar-link 
            to="/dashboard" 
            name="Dashboard" 
            icon="ti-dashboard" 
        />

        <sidebar-link
          to="/products"
          name="Products"
          icon="ti-tag"
        />

        <sidebar-link
          to="/account"
          name="Account"
          icon="ti-user"
        />

        <sidebar-link
            v-if="$config.sites[$config.moniker].scheme === 'multiple'"
          to="/settings"
          name="Settings"
          icon="ti-panel"
        />


        <li class="nav-item">
            <a href="https://support.missingink.com" target="_blank" class="nav-link">
                <i class="ti-support"></i>
                <p>Support</p>
            </a>
        </li>

        <div style="width: 100%; position: absolute; bottom: 0; left: 0">
            <sidebar-link
            to="/logout"
            name="Logout"
            icon="ti-arrow-left"
            />
        </div>

      </template>
      <mobile-menu>
          <drop-down
            class="nav-item"
            :title="this.$config.sites[this.$config.moniker].moniker_display_name"
            title-classes="nav-link"
            icon=""
            shiftleft="true"
          >
          <a class="dropdown-item" href="#" v-for="(site, index) in this.$config.sites" @click="changeMoniker(site.moniker)">
            {{site.moniker_display_name}}
          </a>
          </drop-down>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    changeMoniker (moniker) {
        this.$cookies.set('moniker', moniker);
        this.$updateConfigVariables({ moniker: moniker });
        location.reload(); // Hacky but it works
    }

  },
};
</script>
